import * as React from "react";
const SvgFiRrBulb = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bulb_svg__a)">
      <path
        fill="#062147"
        d="M17.994 2.286A9 9 0 0 0 3.075 7.822a8.94 8.94 0 0 0 2.793 7.76A6.26 6.26 0 0 1 8 20.15v.16A3.694 3.694 0 0 0 11.69 24h.62A3.694 3.694 0 0 0 16 20.31v-.548a5.33 5.33 0 0 1 1.932-4 8.994 8.994 0 0 0 .062-13.477zM12.31 22h-.62A1.69 1.69 0 0 1 10 20.31L9.992 20H14v.31A1.69 1.69 0 0 1 12.31 22m4.3-7.741a7.67 7.67 0 0 0-2.364 3.74H13v-7.183A3 3 0 0 0 15 8a1 1 0 1 0-2 0 1 1 0 1 1-2 0 1 1 0 1 0-2 0 3 3 0 0 0 2 2.816V18H9.678a8.63 8.63 0 0 0-2.448-3.881 7 7 0 0 1 4.78-12.12 6.92 6.92 0 0 1 4.651 1.779 6.993 6.993 0 0 1-.048 10.48z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bulb_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBulb;
